import 'twin.macro';
import React from 'react';
import { ReactComponent as Icon } from './carnet.svg';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';

export function CarnetIcon(props: IconProps) {
  return <Icon className={props.className} />;
}
